import type { Component, Input } from '@builder.io/sdk';

const headingCardField = [
  {
    name: 'heading',
    type: 'string',
  },
  {
    name: 'subheading',
    type: 'string',
  },
] as const satisfies DeepReadonly<Input[]>;
const headingCardConfig = {
  name: 'headingCard',
  inputs: headingCardField,
} as const satisfies Component;

export type HeadingCardProps = GenerateBuilder<typeof headingCardField>;
export default headingCardConfig;
